import React from 'react';
import { Link } from 'react-router-dom';

export default () => (
	<footer className='footer'>
		<div className='container mt-3'>
			<div className='columns is-multiline'>
				<div className='column is-one-third'>
					<h2 className='is-4 subtitle has-text-weight-bold mt-1 mb-1'>Contact Information</h2>
					<p>Business and accounts: <br /> <a className='has-text-weight-bold' href='mailto:info@cloudchefs.co.za'>info@cloudchefs.co.za</a></p>
					<p className='mt-1'>Technical and order support: <br /> <a className='has-text-weight-bold' href='mailto:support@cloudchefs.co.za'>support@cloudchefs.co.za</a>
						<br /> <a className='has-text-weight-bold underline-contact-number' href='tel:0877293498'>087 729 3498</a>
					</p>
				</div>
				<div className='column is-one-third'>
					<h2 className='is-4 subtitle has-text-weight-bold mt-1 mb-1'>Useful Links</h2>
					<div className='columns is-multiline'>
						<div className='column is-one-third'>
							<p>
								<Link to='/'>
									Home
								</Link>
							</p>
							<p>
								<Link to='/about-us'>
									About us
								</Link>
							</p>
							<p>
								<Link to='/contact-us'>
									Contact us
								</Link>
							</p>
						</div>
						<div className='column is-two-thirds'>
							<p>
								<Link to='/become-a-partner'>
									Become a partner
								</Link>
							</p>
							<p>
								<Link to='/register'>
									Create account
								</Link>
							</p>
							<p>
								<Link to='/login'>
									Login
								</Link>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<hr />
		<div className='container content'>
			<p className='has-text-dark mobile-flex'>
				Copyright &copy; Cloud Chefs {new Date().getFullYear()} &nbsp;
				<a
					href='https://res.cloudinary.com/cloudchefscloudinary/image/upload/v1564513097/CORE/Cloud_Chefs_Terms_of_Service_2019.pdf'
					className='has-text-dark footer-item'
					target='_blank'
					rel='noopener noreferrer'
				>
					Terms &amp; Conditions
				</a>
			</p>
			<div className='columns'>
				<div className='column is-one-third'>
					<img className='image mt-2' alt='Paystack Payment Methods' src='https://res.cloudinary.com/cloudchefscloudinary/image/upload/c_scale,w_1400/v1660147439/CORE/SBP_Tag_-_Payment_Channels_-_SA.png' />
				</div>
				{/* <div className='column'>
					<img className='image mt-1' alt='Mobicred Payment Method' src='https://res.cloudinary.com/cloudchefscloudinary/image/upload/f_auto,h_100/v1575217739/CORE/mobicred' />
				</div> */}
			</div>
		</div>
	</footer>
);
